import React, { useEffect, useState } from "react";
import axiosInstance, { axiosTokenInstance } from "../../axiosConfig/axios";

import Slider from "../../components/swiper/slider";
import RestaurantHeader from "./RestaurantHeader";
import TabBar from "./tabbar";
import MenuProductList from "./MenuProductList";
import OfferList from "./OfferList";
import Reviews from "./Reviews";
import "./menu.css";
import ShowCart from "../../components/showCart/showCart";
import Loading from "../../components/loading/loading";
import { useSearchParams } from "react-router-dom";

const RestaurantMenu = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [restaurantSliderImages, setRestaurantSliderImages] = useState([]);
  const [restaurantInfoData, setRestaurantInfoData] = useState([]);
  const [menuCategories, setMenuCategory] = useState({});
  const [restaurantReviews, setRestaurantReviews] = useState({});
  const [offers, setOffers] = useState({});

  const [activeTab, setActiveTab] = useState("المنيو");


  const restaurantId = localStorage.getItem("restaurant");

  const getData = async () => {
    const { data } = await axiosTokenInstance.get(
      `/connector/api/users/menu/${restaurantId}`
    );
    console.log(data?.data);

    setRestaurantSliderImages(data?.data.info.images);
    setRestaurantInfoData(data?.data.info);
    setMenuCategory(data?.data?.variable_categories);
    setOffers(data?.data?.combo_categories);
    setIsLoading(false);
  };

  const getReviews = async () => {
    const { data } = await axiosInstance.get(
      `/connector/api/users/reviews/${restaurantId}`
    );

    setRestaurantReviews(data.data);
  };

  useEffect(() => {
    getData();
    getReviews();
  }, []);

  const userToken = localStorage.getItem("token");

  const tabs = ["المنيو", "عروض", "مراجعات"];
  const categories = [
    ...(menuCategories?.length > 0
      ? menuCategories?.map((category) => category.name)
      : []),
  ];

  // Render content based on activeTab
  const renderTabContent = () => {
    switch (activeTab) {
      case "المنيو":
        return (
          <>
            <TabBar
              tabs={categories}
              nameOfClass="content-tap-button"
              mainClass="tab-bar2"
            />
            <MenuProductList
              menuCategories={menuCategories}
              categories={categories}
            />
          </>
        );
      case "عروض":
        return <OfferList offers={offers} />;

      case "مراجعات":
        return <Reviews reviews={restaurantReviews} />;
      default:
        return null;
    }
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {" "}
          <Slider images={restaurantSliderImages} />
          <div style={{ padding: "0 20px" }}>
            <RestaurantHeader restaurantInfoData={restaurantInfoData} />
          </div>
          <div className="menu-content">
            <TabBar
              tabs={tabs}
              nameOfClass="main-tap-button"
              mainClass="tab-bar1"
              onTabClick={setActiveTab}
            />

            {renderTabContent()}
          </div>
          {userToken && (
            <div style={{ position: "relative" }}>
              <ShowCart />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default RestaurantMenu;
